// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"62807bff","581":"85e44081","993":"ea328426"}[chunkId] + ".chunk.js";
};